// dataLayer pushes for GTM (public/index.html loads the container by
// hostname). GTM turns these into GA4 / Google Ads / Contentsquare / Clarity
// events. Never put names, emails, phone numbers or addresses in a push.

const MARKET_BY_HOST = {
  "booking.tapestodigital.com.au": "AU",
  "booking.tapestodigital.co.uk": "UK",
};

// "AU" / "UK" on the live subdomains, null anywhere else (no GTM there)
export const hostMarket = (hostname = window.location.hostname) =>
  MARKET_BY_HOST[hostname] || null;

export function track(payload) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(payload);
}
